<template>
    <div v-if="anfragen != undefined">
        <div class="container text-center" v-if="anfragen.length == 0">
            <h2 class="text-center pt-5">Keine Anfragen vorhanden</h2>
            <img :src="require('../assets/interface/box.svg')" 
                style="width:8em;height:8em"
            >
        </div>

        <div class="container d-none d-lg-flex flex-row align-items-stretch">
            <anfragen-liste style="border-bottom-right-radius:0" :class="$route.query.aid ? 'transitionWidth w-33' : 'transitionWidth w-100'"/>
            <transition name="shrinkright">
                <anfragen-anzeige v-if="$route.query.aid" class="w-66 rounded"/>
            </transition>
        </div>

        <div class="d-lg-none" style="display:grid">
            <transition :name="$route.query.aid ? 'slideleft' : 'slideright'">
                <anfragen-liste key="3" v-if="$route.query.aid == undefined" 
                    style="grid-column:1;grid-row:1" 
                />
                <div key="4" style="grid-column:1;grid-row:1" v-else>
                    <b-button v-if="$route.query.aid != undefined" 
                        class="mb-2 p-n5" block 
                        style="border-top-right-radius:0; border-top-left-radius:0"
                        @click="$router.push('/nachrichten')"
                    >
                        Zurück
                    </b-button>
                    <anfragen-anzeige />
                </div>
            </transition>
        </div>

        <b-modal title="Anfrage erstellen" ref="modal" 
            v-if="showModal"
            v-model="showModal" 
            cancelTitle="Abbrechen"
            :ok-disabled="loading"
            :cancel-disabled="loading"
            @shown="$refs.txtAreaNew.focus()"
            @cancel="$router.go(-1)" @ok="handleAnfrageSenden"
        >
            <template v-slot:modal-ok>
                Anfrage senden  <b-spinner v-if='loading' small />
            </template>
            Schicke dem User eine Anfrage und klärt so, ob ihr eine Fahrgemeinschaft bilden könnt.<br>
            <strong>Dein Name wird dabei für den User sichtbar.</strong><br><br>
            <b-form>
                <b-form-group label="Nachricht:" label-for="textNachricht">
                    <b-form-textarea size="lg" ref="txtAreaNew" v-model="neueanfrage.nachricht" />
                </b-form-group>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import { setAlert } from '../tools'
import { BSpinner } from "bootstrap-vue"
import AnfragenListe from '../components/AnfragenListe.vue'
import AnfragenAnzeige from '../components/AnfragenAnzeige.vue'
export default {
    name: "Anfragen",
    components:{
        BSpinner,
        AnfragenListe,
        AnfragenAnzeige
    },
    data() {
        return { 
            neueanfrage: {
                empfaengerId: 0,
                nachricht: ""
            },
            showModal: false,
            loading: false
        }
    },
    computed: mapGetters(['anfragen']),
    watch:{
        $route: async function(){
            if(this.$route.query.uid != undefined)
            {
                var anfrage = this.anfragen.find(x => x.teilnehmer.id == this.$route.query.uid)
                if(anfrage != undefined)
                    this.$router.replace({ path: '/nachrichten', query: { aid: anfrage.id }})
                else
                    this.showModal = true
            }
        }
    },
    methods: { 
        ...mapActions(['updateAnfragen', 'sendeAnfrage']),
        async handleAnfrageSenden(){
            this.loading = true
            try {
                this.neueanfrage.empfaengerId = parseInt(this.$route.query.uid)
                var anfrage = await this.sendeAnfrage(this.neueanfrage)
                if(anfrage != undefined)
                    this.$router.push({ path: '/nachrichten', query: { aid: anfrage.id }})
                this.showModal = false
            }
            catch (err) {
                setAlert(this, err.response.data, 'Senden fehlgeschlagen', 'danger')
            }
            this.loading = false
        }
    },
    async created(){
        try {
            await this.updateAnfragen()
        }
        catch (err) {
            setAlert(this, err.response.data, 'Laden fehlgeschlagen', 'danger')
        }
    },
    async mounted(){
        if(this.$route.query.uid != undefined)
        {
            var anfrage = this.anfragen.find(x => x.teilnehmer && x.teilnehmer.id == this.$route.query.uid)
            if(anfrage != undefined)
                this.$router.replace({ path: '/nachrichten', query: { aid: anfrage.id }})
            else
                this.showModal = true
        }
    }
}
</script>

<style scoped>
    .transitionWidth{
        -webkit-transition:  width .5s;
        -moz-transition:  width .5s;
        -ms-transition:  width .5s;
        -o-transition:  width .5s;
        transition:  width .5s;
    }
    .w-33{ width: 33% }
    .w-66{ width: 66%; }


    .shrinkright-enter-active{
        -webkit-transition:  transform .5s ease-in-out, opacity .5s ease-in-out, margin .5s ease-in-out;
        -moz-transition:  transform .5s ease-in-out, opacity .5s ease-in-out, margin .5s ease-in-out;
        -ms-transition:  transform .5s ease-in-out, opacity .5s ease-in-out, margin .5s ease-in-out;
        -o-transition:  transform .5s ease-in-out, opacity .5s ease-in-out, margin .5s ease-in-out;
        transition:  transform .5s ease-in-out, opacity .5s ease-in-out, margin .5s ease-in-out;
        transform-origin: left;
        opacity: 1;
    }
    .shrinkright-leave-active {
        -webkit-transition:  transform .4s ease-in-out, opacity .5s ease-in-out, margin .5s ease-in-out;
        -moz-transition:  transform .4s ease-in-out, opacity .5s ease-in-out, margin .5s ease-in-out;
        -ms-transition:  transform .4s ease-in-out, opacity .5s ease-in-out, margin .5s ease-in-out;
        -o-transition:  transform .4s ease-in-out, opacity .5s ease-in-out, margin .5s ease-in-out;
        transition:  transform .4s ease-in-out, opacity .5s ease-in-out, margin .5s ease-in-out;
        transform-origin: left;
        opacity: 1;
    }
    .shrinkright-enter{
        transform: scaleX(0);
        opacity: 0;
        margin-right: -100%;
    }
    .shrinkright-leave-to{
        transform: scaleX(0);
        opacity: 0;
        margin-right: -100%
    }

    .slideleft-enter-active, .slideleft-leave-active, .slideright-enter-active, .slideright-leave-active {
        -webkit-transition:  transform .5s ease-in-out, opacity .5s ease-in-out;
        -moz-transition:  transform .5s ease-in-out, opacity .5s ease-in-out;
        -ms-transition:  transform .5s ease-in-out, opacity .5s ease-in-out;
        -o-transition:  transform .5s ease-in-out, opacity .5s ease-in-out;
        transition:  transform .5s ease-in-out, opacity .5s ease-in-out;
    }
    .slideright-enter{
        opacity: 0;
        transform: translateX(-100%)
    }
    .slideright-leave-to{
        opacity: 0;
        transform: translateX(100%)
    }
    .slideleft-enter{
        opacity:0;
        transform: translateX(100%)
    }
    .slideleft-leave-to{
        opacity: 0;
        transform: translateX(-100%)
    }
</style>
